<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="pa-3 px-md-5" flat>
                <v-card-title class="subheading font-weight-black primary--text px-0">Tipo</v-card-title>
                <v-container fluid grid-list-sm white>
                    <v-layout row wrap>
                        <v-flex xs12 sm12>
                            <v-text-field
                                v-model="titulo"
                                class="required-field"
                                name="Título Tipo"
                                key="Titulo-Tipo"
                                :counter="100"
                                v-validate="'required|max:100'"
                                :disabled="!devePermitirEdicao"
                                :error-messages="errors.collect('Título Tipo')"
                                label="Título"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-textarea
                                v-model="descricao"
                                name="Descrição Tipo"
                                key="Descricao-Tipo"
                                class="required-field"
                                :counter="250"
                                v-validate="'required|max:250'"
                                :disabled="!devePermitirEdicao"
                                :error-messages="errors.collect('Descrição Tipo')"
                                label="Descrição"
                                auto-grow
                                rows="1"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-divider class="my-4"/>

                <div class=" mb-4">
                    <v-btn :disabled="deveDeshabilitarBotaoNovoReajuste"
                           v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                           small color="primary"
                           @click.stop="deveMostrarModalInserirNovoReajuste = true">
                            <v-icon small>add_circle_outline</v-icon>
                            <span class="ml-2"> Novo Reajuste </span>
                    </v-btn>
                </div>

                <historico-reajuste-indice-preco :reajustes="reajustes"
                                                 @eventoRemoverReajuste="(reajuste) => $emit('eventoRemoverReajuste', reajuste)"
                                                 @eventoSalvarNovoPercReajuste="(dados) => $emit('eventoSalvarNovoPercReajuste', dados)"/>
                <v-divider></v-divider>
                <v-card-actions class="acoes justify-space-between">
                    <v-btn color="botao-cancelar-color" outline flat @click="cancelar">Cancelar</v-btn>
                    <v-btn color="primary" depressed
                           v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                           :disabled="!houveModificacao"
                           @click="validarESalvar">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>

        <modal-inserir-novo-reajuste :deveMostrarModalInserirNovoReajuste="deveMostrarModalInserirNovoReajuste"
                                     :historico-reajustes="reajustes"
                                     v-model="dadosNovoReajuste"
                                     @fecharModalNovoReajuste="processarEventoFecharModalInserirNovoReajuste"
                                     @eventoSalvarNovoReajuste="propagarEventoSalvarNovoReajuste"/>
    </v-layout>
</template>
<script>

import HistoricoReajusteIndicePreco from '../../components/HistoricoReajusteIndicePreco'
import ModalInserirNovoReajuste from '@/views/pages/comprador/cadastros/components/ModalInserirNovoReajuste.vue'
import { mapState } from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'

const dadosIniciasNovoReajuste = {
    anoBase: (new Date()).getFullYear(),
    anoIndicador: (new Date()).getFullYear() - 1,
    indicador: 'IPCA',
    valorBase: null,
    percentualReajuste: null
}

export default {
    name: 'NovoReajusteEHistorico',
    components: {ModalInserirNovoReajuste, HistoricoReajusteIndicePreco },
    inject: ['$validator'],
    props: {
        modalidade: {
            type: Object,
            required: false
        },
        reajustes: {
            type: Array,
            required: false
        },
    },
    data: () => {
        return {
            titulo: '',
            descricao: '',
            houveModificacao: false,
            dictionary: {
                attributes: {
                    titulo: 'Título',
                    descricao: 'Descrição'
                },
                custom: {
                    titulo: {
                        required: () => 'O campo Título é obrigatório',
                        max: 'O campo Título deve conter no máximo 100 caracteres'
                    },
                    descricao: {
                        required: () => 'O campo Descrição é obrigatório',
                        max: 'O campo Descrição deve conter no máximo 250 caracteres'
                    },
                }
            },
            dadosNovoReajuste: { ...dadosIniciasNovoReajuste },
            deveMostrarModalInserirNovoReajuste: false
        }
    },
    async mounted() {
        if (this.modalidade) {
            this.titulo = this.modalidade.titulo
            this.descricao = this.modalidade.descricao
        }

        this.$nextTick(() => {
            this.houveModificacao=false
        })

        this.$validator.localize('pt-BR', this.dictionary)
    },
    computed: {
        ...mapState(['loki']),
        deveDeshabilitarBotaoNovoReajuste(){
            return this.reajustes.length > 0
        },
        devePermitirEdicao(){
            return azAuth(this.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
        }
    },
    methods: {
        async validarESalvar() {
            const tituloEstaValidado = await this.$validator.validate('Título Tipo')
            const descricaoEstaValidado = await this.$validator.validate('Descrição Tipo')

            if (!tituloEstaValidado || !descricaoEstaValidado)
                throw new Error('Preencha todos os campos obrigatórios')

            const payload = {
                id: this.modalidade? this.modalidade.id : null,
                titulo: this.titulo,
                descricao: this.descricao
            }

            this.$emit('eventoSalvarTipo', payload)
            this.mostrarNotificacaoSucessoDefault()
            this.resetar()
        },
        cancelar() {
            this.$emit('voltarParaListagem')
            this.resetar()
        },
        resetar() {
            this.$validator.reset()
            this.houveModificacao=false
        },
        processarNovoReajuste() {
            this.$emit('processarNovoReajuste')
        },
        processarEventoFecharModalInserirNovoReajuste(){
            this.deveMostrarModalInserirNovoReajuste = false
            Object.assign(this.dadosNovoReajuste, dadosIniciasNovoReajuste)
        },
        propagarEventoSalvarNovoReajuste() {
            const { anoBase, anoIndicador, ...data} = this.dadosNovoReajuste

            const reajuste = {
                ano: anoBase,
                modalidade: this.modalidade,
                ...data
            }

            this.$emit('eventoSalvarNovoReajuste', reajuste)

            this.processarEventoFecharModalInserirNovoReajuste()
        },
    },
    watch: {
        titulo() {
            this.houveModificacao=true
        },
        descricao() {
            this.houveModificacao=true
        }
    },
}
</script>

<style scoped lang="stylus">
.v-select-list
    overflow hidden
    white-space nowrap

</style>